<template>
    <div>
    <div id="tab1" class="t-color-content1 pdt-16 pdb-32">
    <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
        <div>
          <button class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r">계정 관리</button>
          <button class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r">로그인 또는 로그아웃</button>
        </div>
        <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">서비스에 로그아웃</div>
        <div class="t-body3 t-color-content1 l-spacing42 font-r">서비스를 사용 중인 기기에 따라 로그아웃하거나 계정을 삭제하거나 다른 조치를 취할 수 있습니다.</div>
        <div class="pdt-24">
          <button
            class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r font-11"><i
              class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개</button>
        </div>
      </div>
    </div>
     <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
       <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
         <div>
           <button
             class="t-helper t-color-white bg-blue3 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
             font-r">설정</button>
           <button
             class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
             font-r">설정 변경</button>
         </div>
         <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">서비스 설정 변경하기</div>
         <div class="t-body3 t-color-content1 l-spacing42 font-r">전화 번호를 추가하거나 알림 수신 설정을 변경합니다.
           <a href="https://www.google.com/search?source">https://www.google.com/search?source</a>
         </div>
       </div>
     </div>
      <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
        <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
          <div>
            <button
              class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
              font-r">문제 해결</button>
            <button
              class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
              font-r">동기화</button>
          </div>
          <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">서비스 설정 변경하기</div>
          <div class="t-body3 t-color-content1 l-spacing42 font-r">안드로이드 앱이 자동으로 동기화되지 않으면 다음과 같은 문제가 발생할 수 있습니다. 각 단계를
            수행한 …
          </div>
          <div class="pdt-24">
            <button
              class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r font-11"><i
                class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개</button>
          </div>
        </div>
      </div>


  </div>


  
  <div id="tab2" class="t-color-content1 pdt-16 pdb-32">
    <div class="pdl-16 pdr-16 pdb-16 mgb-16 listItems d-flex justify-content-between">
      <div class="t-body2 t-color-content1  font-m d-flex align-items-center">나의 문의 <span
          class="queryCount bg-dark t-color-white t-caption t-center w-18 h-16 d-inline-block mgl-4">22</span></div>
      <div class="t-body2 t-color-warning  font-m">1:1 문의하기</div>
    </div>
    <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
        <div>
          <button
            class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r">계정 관리</button>
          <button
            class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36 font-r">로그인 또는 로그아웃</button>
        </div>
        <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">온라인 강의는 꼭 구매해야 하나요?</div>
        <div class="t-body3 t-color-content1 l-spacing42 font-r">서비스를 사용 중인 기기에 따라 로그아웃하거나 계정을 삭제하거나 다른 조치를 취할 수 있습니다.
        </div>
        <div class="pdt-24">
          <button
            class="t-helper t-color-blue3 bg-gray d-flex align-items-center pdt-5 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r"><i
              class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개</button>
        </div>
      </div>
    </div>
    <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
        <div>
          <button class="t-helper t-color-white bg-blue3 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
             font-r">설정</button>
          <button class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
             font-r">설정 변경</button>
        </div>
        <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">온라인 강의는 어떻게 수료할 수 있나요?</div>
        <div class="t-body3 t-color-content1 l-spacing42 font-r">전화 번호를 추가하거나 알림 수신 설정을 변경합니다.
        https://www.google.com/search?source
          <a href="https://www.google.com/search?source">https://www.google.com/search?source</a>
        </div>
      </div>
    </div>
    <div class="pdl-16 pdr-16 pdt-16px pdb-16px">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default ">
        <div>
          <button class="t-helper t-color-white bg-dark d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
              font-r">문제 해결</button>
          <button class="t-helper t-color-white bg-blue1 d-inline-block pdt-5 pdb-4 pdl-4 pdr-4 b-radius2 l-spacing36
              font-r">동기화</button>
        </div>
        <div class="t-subtitle3 t-color-title l-spacing48 pdt-10 pdb-8 font-m">저는 안드로이드 기기 유저인데 앱에서 자동 동기화 오류가 발생하는 것 같아요</div>
        <div class="t-body3 t-color-content1 l-spacing42 font-r">안드로이드 앱이 자동으로 동기화되지 않으면 다음과 같은 문제가 발생할 수 있습니다. 각 단계를 수행한 …
        </div>
        <div class="pdt-24">
          <button
            class="t-helper t-color-blue3 bg-gray d-flex align-items-center pd5-4 pdb-5 pdl-4 pdr-4 b-radius2 mgb-4 font-r"><i
              class="material-icons font-16 pdr-8">attach_file</i>첨부파일 1개</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import learnApi from '@/api/learnApi.js'

export default {
    props: ['degree', 'status'],
    data() {
        return {
            learnProgressRate: {}
        }
    },

    components: {
        'ListItemProgress': () => import('@/components/learn/ListItemProgress.vue'),
    },

    mounted() {
        const selectorCard = `#myDegreeCard${this.degree.id}`
        const ripplesCard = [].map.call(document.querySelectorAll(selectorCard), function(el) {
            return new MDCRipple(el);
        })

        const selectorButton = `#myDegreeMore${this.degree.id}`
        const ripplesButton = [].map.call(document.querySelectorAll(selectorButton), function(el) {
            let button = new MDCRipple.attachTo(el)
            button.unbounded = true
            return button
        })
        
    },

    computed: {
        
    },
    methods: {
        // 학습진행율 데이터 (get learning status data)
        toggleProgress(id) {
            learnApi.learnProgressRate({id: id}).then((response) => {
                this.learnProgressRate = response.data.data
                console.log(this.learnProgressRate)
                this.$emit('initProgressStatus', id)                
            }).catch((err) => {
            })
        },

        // move learn view
        moveLearnView(degree) {
            if (degree.learning) {
                this.$router.push({
                    name: 'LearnView', 
                    query: this.$route.query,
                    params: {learnId: degree.id}
                })
            }else {
                this.$alert({
                    title: this.$t('72'),   // 학습을 중단한 강의입니다.
                    content: this.$t('73'), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
                    accept: this.$t('74'), // 확인
                }).then(() => {
                }).catch(() => {                        
                })
            }
            // this.$router.push({
            //         name: 'LearnView', 
            //         query: this.$route.query,
            //         params: {learnId: degree.id}
            //     })
        }
    }
}
</script>